import type * as SchemaTypes from '../../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateStrengthAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitStrengthResultInput;
}>;


export type CreateStrengthAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitStrengthResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'message' | 'field'>
    )>> }
  ) | (
    { __typename: 'SubmitStrengthResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & StrengthAssessmentResultFragment
    )> }
  ) }
);

export type StrengthAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt' | 'completedAt' | 'updatedAt' | 'updatedBy' | 'isDeleted'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'role' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'CardioRespResult' } | { __typename: 'InbodyCompositionResult' } | { __typename: 'IndividualMotivationResult' } | { __typename: 'ML360Result' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | (
    { __typename: 'StrengthResult' }
    & StrengthAssessmentResultDataFragment
  ) | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type StrengthAssessmentResultDataFragment = (
  { __typename: 'StrengthResult' }
  & Pick<SchemaTypes.StrengthResult, 'squatRepMaxKg' | 'deadliftRepMaxKg' | 'maxPullUps' | 'sprintDragCarrySec'>
);

export const StrengthAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment StrengthAssessmentResultData on StrengthResult {
  squatRepMaxKg
  deadliftRepMaxKg
  maxPullUps
  sprintDragCarrySec
}
    `;
export const StrengthAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment StrengthAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      role
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on StrengthResult {
      ...StrengthAssessmentResultData
    }
  }
  createdAt
  completedAt
  updatedAt
  updatedBy
  isDeleted
}
    `;
export const CreateStrengthAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation CreateStrengthAssessmentResult($input: SubmitStrengthResultInput!) {
  submitStrengthResult(input: $input) {
    __typename
    ... on SubmitStrengthResultSuccessfulResponse {
      result {
        ...StrengthAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        message
        field
      }
    }
  }
}
    ${StrengthAssessmentResultFragmentDoc}
${StrengthAssessmentResultDataFragmentDoc}`;
export type CreateStrengthAssessmentResultMutationFn = Apollo.MutationFunction<CreateStrengthAssessmentResultMutation, CreateStrengthAssessmentResultMutationVariables>;

/**
 * __useCreateStrengthAssessmentResultMutation__
 *
 * To run a mutation, you first call `useCreateStrengthAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStrengthAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStrengthAssessmentResultMutation, { data, loading, error }] = useCreateStrengthAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStrengthAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<CreateStrengthAssessmentResultMutation, CreateStrengthAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStrengthAssessmentResultMutation, CreateStrengthAssessmentResultMutationVariables>(CreateStrengthAssessmentResultDocument, options);
      }
export type CreateStrengthAssessmentResultMutationHookResult = ReturnType<typeof useCreateStrengthAssessmentResultMutation>;
export type CreateStrengthAssessmentResultMutationResult = Apollo.MutationResult<CreateStrengthAssessmentResultMutation>;
export type CreateStrengthAssessmentResultMutationOptions = Apollo.BaseMutationOptions<CreateStrengthAssessmentResultMutation, CreateStrengthAssessmentResultMutationVariables>;